/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import styled from "styled-components";
import { devices } from "components/shared/Styles";
import { imageWidth, GuidePageCaption } from "./GuidePageSimpleBlocks";
import { CmsPlayerAttributes } from "api/CmsApi";

export const GuidePagePlayerBlock: React.FC<{
  media: CmsPlayerAttributes;
  type: "video" | "audio";
}> = ({ media, type }) => {
  return (
    <GuidePageVideoContainer>
      <GuidePageVideo as={type} src={media.url} controlsList="nodownload" />
      {media.caption && <GuidePageCaption>{media.caption}</GuidePageCaption>}
    </GuidePageVideoContainer>
  );
};

const GuidePageVideo = styled.video.attrs({
  autoPlay: false,
  loop: false,
  muted: false,
  controls: true,
  disablePictureInPicture: false,
  playsInline: true,
})`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 24px;
`;

const GuidePageVideoContainer = styled.div`
  display: block;
  ${imageWidth}
  margin: 64px auto;

  ${devices.small} {
    margin: 32px auto;
  }
`;
